import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import "./subColumn.scss";

const SubColumn = ({ processPaths, columnLen, columnNum, isOneColumn }) => {
  return (
    <Column spacing="100">
      {processPaths
        .slice(
          columnLen * columnNum,
          isOneColumn ? processPaths.length : columnLen * columnNum + columnLen
        )
        .map((path, index) => (
          <Row key={index} spacing="300">
            <div className="checkStyle">✔</div>
            <Text type={"b300"}>{path}</Text>
          </Row>
        ))}
    </Column>
  );
};

export default SubColumn;
